// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.course-list {
    display: flex;
    justify-content: center;
}
.btn-creat-course {
    float: right;
    margin-top: 5px;
}
tbody {
    cursor: pointer;
}

td {
    text-align: inherit;
}

.title {
    display: flex;
    justify-content: center;
    font-size: 18px;
    font-weight: bold;
}

.right {
    float: right;
}`, "",{"version":3,"sources":["webpack://./src/pages/Majorcourse/AllCourses/Courses.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,uBAAuB;AAC3B;AACA;IACI,YAAY;IACZ,eAAe;AACnB;AACA;IACI,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,YAAY;AAChB","sourcesContent":[".course-list {\r\n    display: flex;\r\n    justify-content: center;\r\n}\r\n.btn-creat-course {\r\n    float: right;\r\n    margin-top: 5px;\r\n}\r\ntbody {\r\n    cursor: pointer;\r\n}\r\n\r\ntd {\r\n    text-align: inherit;\r\n}\r\n\r\n.title {\r\n    display: flex;\r\n    justify-content: center;\r\n    font-size: 18px;\r\n    font-weight: bold;\r\n}\r\n\r\n.right {\r\n    float: right;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
